import { Box, Chip, Toolbar, Typography } from "@mui/material";
import Products from "./dashboardPages/Products";
import Contact from "./dashboardPages/Contact";
import Seasonals from "./dashboardPages/Seasonals";
import Orders from "./dashboardPages/Orders";
import Cart from "./dashboardPages/Cart";
import TopSellers from "./dashboardPages/TopSellers";
import { usePage } from "../context/PageContext";

const sections = [
  { key: "Products", component: <Products /> },
  { key: "Seasonal", component: <Seasonals /> },
  { key: "Top Sellers", component: <TopSellers /> },
  { key: "Cart", component: <Cart /> },
  { key: "Orders", component: <Orders /> },
  { key: "Contact", component: <Contact /> },
];

export default function Dashboard() {
  const { activeSection } = usePage();

  const currentSection = sections.find((s) => s.key === activeSection)
    ?.component || <Typography variant="h6">Select an option</Typography>;

  return (
    <Box
      component="main"
      id="main-content"
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        minHeight: "100vh",
        px: { xs: 1, sm: 2.5, md: 5 },
        pt: { xs: 2, md: 3 },
        pb: 8,
        background: "linear-gradient(180deg, #F7F3EC 0%, #FFFDF8 55%, #F7F3EC 100%)",
      }}
    >
      <Toolbar />
      <Box sx={{ maxWidth: 1460, mx: "auto", px: { xs: 2, md: 3 }, pt: { xs: 3, md: 5 }, pb: 1 }}>
        <Chip label="Rustic World collection" color="secondary" variant="outlined" size="small" sx={{ mb: 1.5 }} />
        <Typography variant="h2" sx={{ fontSize: { xs: "2.8rem", md: "4.4rem" }, lineHeight: 1 }}>
          {activeSection}
        </Typography>
        <Typography sx={{ mt: 1.5, color: "text.secondary", maxWidth: 620 }}>
          Explore considered pieces, manage your selections and keep every order in one place.
        </Typography>
      </Box>
      {currentSection}
    </Box>
  );
}
